// Before a server call that reads the show (the server save, the server page change): make sure
// this tab's own edits to THIS show have reached the server, because the server reads Firestore,
// not this tab.
//
// Replaces db.waitForPendingWrites (14 Oct 2026, CUELIST_SESSION_HANG_2026-10-14.md): in SDK 8 it
// can wait forever on a write filed under "no user" that is never sent while signed in. This
// instead reads this show from the local cache only (no server round trip, no write, no function
// triggers) and checks the SDK's hasPendingWrites flag, which covers only the signed-in user's
// unsent edits to those documents. Polls until clear; never waits past timeoutMs.
const PARTS = ['cues', 'notes', 'layers', 'scriptMarkers'];

const pendingIn = ref => ref.get({ source: 'cache' })
    .then(snap => !!(snap && snap.metadata && snap.metadata.hasPendingWrites))
    .catch(() => false); // not in the cache: nothing of ours is waiting there

// eslint-disable-next-line import/prefer-default-export
export async function waitForShowEditsSent({
    db, projectId, timeoutMs = 10000, pollMs = 200,
    now = () => Date.now(), sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
}) {
    const project = db.collection('projects').doc(projectId);
    const refs = [project, ...PARTS.map(p => project.collection(p))];
    const deadline = now() + timeoutMs;
    for (;;) {
        // eslint-disable-next-line no-await-in-loop
        const pending = (await Promise.all(refs.map(pendingIn))).some(Boolean);
        if (!pending) return 'sent';
        if (now() >= deadline) throw new Error(`Edits to this show have not reached the server after ${timeoutMs} ms`);
        // eslint-disable-next-line no-await-in-loop
        await sleep(pollMs);
    }
}


// WEBPACK FOOTER //
// ./src/lib/show-edits-sent.js